"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logo = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Styled = styled_components_1.default.div `
	transition: color 0.3s ${(p) => p.theme.easing};
	color: ${(p) => p.theme.palette.text.primary};
	margin: 5px 0 16px 16px;

	svg {
		display: inline-block;
		height: 100%;

		transition: fill 0.3s ${(p) => p.theme.easing};
		fill: ${(p) => p.theme.palette.text.primary};
		path {
			transition: fill 0.3s ${(p) => p.theme.easing};
			fill: ${(p) => p.theme.palette.text.primary};
		}
	}

	i {
		font-size: 28px;
		font-weight: 400;
		line-height: 22px;
	}

	a {
		text-decoration: none;
		color: ${(p) => p.theme.palette.text.primary};
		transition: fill 0.3s ${(p) => p.theme.easing}, color 0.3s ${(p) => p.theme.easing};
		&:hover {
			color: ${(p) => p.theme.palette.accent.text};

			svg {
				fill: ${(p) => p.theme.palette.accent.text};
				path {
					fill: ${(p) => p.theme.palette.accent.text};
				}
			}
		}
	}

	&.ue,
	&.eg {
		margin-top: -3px;
	}

	${(p) => p.theme.breakpoints.down("sm")} {
		&:last-child {
			margin-right: 16px;
		}
	}
`;
const Logo = ({ id, href: logoHref, title, locale = "en-US", epicLogoConfig }) => {
    let href = logoHref || "";
    let icon = react_1.default.createElement("i", { title: title, className: `eg-footer-icon-${id}` });
    if (id === "eg") {
        icon = react_1.default.createElement(epic_games_nav_shared_1.EGShieldSvg, Object.assign({}, epicLogoConfig));
        href = `https://www.epicgames.com/${locale}/?lang=${locale}`;
    }
    else if (id === "ue") {
        icon = react_1.default.createElement(epic_games_nav_shared_1.UELogoSvg, Object.assign({}, epicLogoConfig));
        href = `https://www.unrealengine.com/${locale}/?lang=${locale}`;
    }
    else if (id === "tw") {
        href = `https://www.twinmotion.com/${locale}/?lang=${locale}`;
    }
    return (react_1.default.createElement(Styled, { className: `logo ${id}` }, href ? (react_1.default.createElement("a", { onMouseDown: epic_games_nav_shared_1.stopFocusOnClick, title: title, href: href }, icon)) : (icon)));
};
exports.Logo = Logo;
//# sourceMappingURL=Logo.atom.js.map